export default __webpack_public_path__ + "static/media/services_tir_pneu_service.38a8daf5.svg";